<form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

    <div class="row">
        <div class="col-3">

            <div class="form-group">
                <label for="ident_num">{{ 'ORGANIZATION.BIN_ORGANIZATION' | translate }}
                    <svg-icon src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                </label>
                <input type="text" class="form-control" id="ident_num" formControlName="ident_num">
                <div *ngIf="errorMessages">
                    <div *ngFor="let item of errorMessages.ident_num">
                        <div class="text-error" *ngIf="validation('ident_num', item.type)">
                            {{ item.message | translate: item.options }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-6">
<!-- 
            <div class="form-group">
                <label for="legal_form_id"> {{ 'ORGANIZATION.TYPE_OF_ORGANIZATION' | translate }}</label>
                <select class="form-control" id="legal_form_id" formControlName="legal_form_id">
                    <option *ngFor="let legalForm of legalForms" [value]="legalForm.id">{{ legalForm.short_name }}</option>
                </select>
            </div> -->

            <ff-input-lang label="{{ 'NAME' | translate }}" hint="{{ 'ORGANIZATION.NAME_ORGANIZATION_IN_ALL_LANGUAGES' | translate }}"
                fieldId="name"
                fieldName="name"
                fieldType="text"
                [clearField]="ffInputLangParams.name.clearField"
                [required]="ffInputLangParams.name.required"
                [inputValue]="orgName"
                (changeValue)="eventFnFF('name', $event)">
            </ff-input-lang>
        </div>
        <!-- <div class="col-3">

            <div class="form-group">
                <label for="structural_level_id"> {{ 'ORGANIZATION.STRUCTURAL_LEVEL' | translate }}</label>
                <select class="form-control" id="structural_level_id" formControlName="structural_level_id">
                    <option *ngFor="let structuralLevel of structuralLevels" [value]="structuralLevel.id">{{ structuralLevel.name }}</option>
                </select>
            </div>
        </div> -->
        <div class="col-3">

            <div class="form-group">
                <label for="orole_id">{{ 'ROLE' | translate }}
                    <svg-icon src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                </label>
                <select class="form-control" id="orole_id" formControlName="orole_id">
                    <option *ngFor="let orole of oroles" [value]="orole.id">{{ orole.name }}</option>
                </select>
                <!-- <div *ngIf="errorMessages">
                    <div *ngFor="let item of errorMessages.orole_id">
                        <div class="text-error" *ngIf="validation('orole_id', item.type)">
                            {{ item.message | translate: item.options }}
                        </div>
                    </div>
                </div> -->
            </div>

        </div>

    </div>

    <div class="row">

        <!-- <div class="col-12">

            <ff-input-lang label="{{ 'NAME' | translate }}" hint="{{ 'ORGANIZATION.NAME_ORGANIZATION_IN_ALL_LANGUAGES' | translate }}"
                fieldId="name"
                fieldName="name"
                fieldType="text"
                [clearField]="ffInputLangParams.name.clearField"
                [required]="ffInputLangParams.name.required"
                [inputValue]="orgName"
                (changeValue)="eventFnFF('name', $event)">
            </ff-input-lang>
        </div>
        <div class="col-12">

            <div formArrayName="addresses">

                <div *ngFor="let item of form.get('addresses')['controls']; let i = index;">

                    <div class="row" [formGroupName]="i">

                        <div class="col-12" *ngIf="i <= 1">
                            <div class="form-sub-title" *ngIf="item.get('address_type').value == 'legal'"> {{ 'ADDRESS.LEGAL_ADDRESS_OF_THE_ORGANIZATION' | translate }}</div>
                            <div class="form-sub-title" *ngIf="item.get('address_type').value == 'actual'"> {{ 'ADDRESS.ACTUAL_ADDRESS_OF_THE_ORGANIZATION' | translate }}</div>
                        </div>

                        <div class="col-3">
                            <div class="form-group">
                                <label for="locality_{{i}}" class="label"> {{ 'ADDRESS.LOCALITY' | translate }}</label>
                                <input type="text" class="form-control" id="locality_{{i}}" formControlName="locality">
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-group">
                                <label for="street_{{i}}" class="label"> {{ 'ADDRESS.STREET' | translate }}</label>
                                <input type="text" class="form-control" id="street_{{i}}" formControlName="street">
                            </div>
                        </div>

                        <div class="col-2">
                            <div class="form-group">
                                <label for="home_{{i}}" class="label"> {{ 'ADDRESS.HOUSE' | translate }}</label>
                                <input type="text" class="form-control" id="home_{{i}}" formControlName="home">
                            </div>
                        </div>

                        <div class="col-4 address-last-col">
                            <div class="form-group">
                                <label for="index_{{i}}" class="label"> {{ 'ADDRESS.INDEX' | translate }}</label>
                                <input type="text" class="form-control" id="index_{{i}}" formControlName="index">
                            </div>

                            <div class="remove-address-field" *ngIf="item.get('address_type').value != 'legal' && (i + 1) > 2">
                                <button type="button" class="btn btn-danger" (click)="removeAddressField(i)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div class="row">
                <div class="col-12">

                    <div class="add-address-field">
                        <button type="button" class="btn btn-primary btn-sm" (click)="addAddressField('actual')">
                            <i class="bi bi-plus-circle"></i> {{ 'ADDRESS.ADD_ADRESS' | translate }}
                        </button>
                    </div>

                </div>
            </div>

        </div>
        <div class="col-12">

            <div formArrayName="banks">

                <div *ngFor="let item of form.get('banks')['controls']; let i = index;">

                    <div class="row" [formGroupName]="i">

                        <div class="col-12">
                            <div class="form-sub-title">{{ 'ORGANIZATION.BANK_DETAILS' | translate }}</div>
                        </div>

                        <div class="col-6">

                            <div class="form-group">
                                <label for="bank_id"> {{ 'ORGANIZATION.BANK' | translate }}</label>
                                <select class="form-control" id="bank_id" formControlName="bank_id">
                                    <option *ngFor="let bank of banks" [value]="bank.id">{{ bank.name }}</option>
                                </select>
                            </div>

                        </div>

                        <div class="col-2">
                            <div class="form-group">
                                <label for="bic_{{i}}" class="label"> {{ 'ORGANIZATION.BTS' | translate }}</label>
                                <input type="text" class="form-control" id="bic_{{i}}" formControlName="bic">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <label for="account_{{i}}" class="label"> {{ 'ORGANIZATION.IID' | translate }}</label>
                                <input type="text" class="form-control" id="account_{{i}}" formControlName="account">
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
        <div class="col-12">

            <div class="row" [formGroup]="form.controls.vat_payer">

                <div class="col-12">
                    <div class="form-sub-title">{{ 'ORGANIZATION.VAT' | translate }}</div>
                </div>

                <div class="col-4">

                    <div class="form-group">
                        <label for="vat_payer_id"> {{ 'ORGANIZATION.VAT_PAYER' | translate }}</label>
                        <select class="form-control" id="vat_payer_id" formControlName="vat_payer_id">
                            <option *ngFor="let vatPayer of vatPayers" [value]="vatPayer.id">{{ vatPayer.name }}</option>
                        </select>
                    </div>

                </div>

                <div class="col-2">

                    <div class="form-group">
                        <label for="seria"> {{ 'ORGANIZATION.VAT_SERIES' | translate }}</label>
                        <input type="text" class="form-control" id="seria" formControlName="seria">
                    </div>

                </div>

                <div class="col-2">

                    <div class="form-group">
                        <label for="number"> {{ 'ORGANIZATION.VAT_NUMBER' | translate }}</label>
                        <input type="text" class="form-control" id="number" formControlName="number">
                    </div>

                </div>

                <div class="col-4">

                    <div class="form-group">
                        <label for="date"> {{ 'DATE' | translate }}</label>
                        <div class="input-group">
                            <input class="form-control" formControlName="date" id="date" readonly="true" ngbDatepicker #d="ngbDatepicker">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button">
                                    <i class="bi bi-calendar-event"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div> -->

        <div class="col-12">

            <div class="row">

                <div class="col-12">
                    <div class="form-sub-title"> {{ 'IMG.IMG_UPLOAD' | translate }}: </div>
                </div>

            </div>

            <div class="row">

                <div class="col-6">

                    <div *ngIf="!form.get('logo_pic').value">
                        <ff-button-upload-files label="{{ 'IMG.LOGO_UPLOAD' | translate }}" component="organization"
                            (uploadedFiles)="uploadedFile($event, 'logo')">
                            <i class="bi-person-circle"></i>
                        </ff-button-upload-files>
                    </div>

                    <div class="image-box" *ngIf="form.get('logo_pic').value">
                        <label> {{ 'IMG.LOGO' | translate }}:</label>
                        <div class="image">
                            <img src="{{ logo }}" alt="logo">
                        </div>
                        <button class="btn btn-light delete-img" type="button" (click)="onDeleteFiles('logo')"
                            ngbTooltip="{{ 'IMG.IMG_DEL' | translate }}">
                            <i class="bi bi-x-circle"></i>
                        </button>
                    </div>

                </div>

                <div class="col-6">

                    <div *ngIf="!form.get('background_pic').value">
                        <ff-button-upload-files label="{{ 'IMG.BG_IMG_UPLOAD' | translate }}" component="organization"
                            (uploadedFiles)="uploadedFile($event, 'background')">
                            <i class="bi bi-card-image"></i>
                        </ff-button-upload-files>
                    </div>

                    <div class="image-box img-bg" *ngIf="form.get('background_pic').value">
                        <label> {{ 'IMG.BG_IMG' | translate }}:</label>
                        <div class="image">
                            <img src="{{ background }}" alt="logo">
                        </div>
                        <button class="btn btn-light delete-img" type="button" (click)="onDeleteFiles('background')"
                            ngbTooltip="{{ 'IMG.IMG_DEL' | translate }}">
                            <i class="bi bi-x-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>